import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import styles from "../styles/components/about.module.scss"
const About = ({ image }) => (
  <section
    className={styles.main}
    id="about"
    aria-label="About Lifetime Fitness"
  >
    <div className={styles.image}>
      <Img fluid={image} alt="Personal training at Lifetime Fitness" />
    </div>
    <div className={styles.cards}>
      <article>
        <h2>Caring environment</h2>
        <p>
          Enjoy the environment you're in and stay consistent. Lifetime Fitness
          is a welcoming second home, with people who care about your progress.
        </p>
      </article>
      <article>
        <h2>Join our gym family</h2>
        <p>
          We are a family that's there to help you reach your goals. Have fun
          along the way, alongside people who care.
        </p>
      </article>
      <article>
        <h2>Personalized training</h2>
        <p>
          Every member gets a personalized diet and training program that suits
          their lifestyle, food preferences and fitness goals.
        </p>
      </article>
    </div>
  </section>
)
export default About
